// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__irEf+","container":"Modal_container__npuMR","close":"Modal_close__q6SF7","content":"Modal_content__GCsuW","image":"Modal_image__8dSPy"};